import { pickThemeColor, pickThemeFontStyles } from '@/theme';
import styled from 'styled-components';

export const StyledTitle = styled.p`
  ${pickThemeFontStyles('20', '26', 'SEMI_BOLD')};
  color: ${pickThemeColor('GREY_NERO')};
  margin: 0;

  &::before {
    counter-increment: section;
    content: counter(section) '. ';
  }
`;

export const StyledCard = styled.section`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 2rem;
`;

export const StyledTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
`;

export const StyledActionsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;
